<template>
    <div>
<!--        <strong>{{ getActorName() }}</strong>-->
<!--        joined to chat with-->
<!--        <strong>{{ $_.get(activity, "payload.fullname") }} </strong>-->
        <span v-html="$t('notification.chatJoined', {agent: getActorName(), visitor: maskedPayloadFullname })"></span>
    </div>
</template>
<script>
import Vue from "vue";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default Vue.extend({
    name: "ChatJoined",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        maskedPayloadFullname() {
            return this.maskVisitorDisplayName(this.$_.get(this.activity, "payload.fullname"));
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.maskVisitorDisplayName(this.$_.get(this.activity, "refVisitor.fullname"));
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
